export default (params) => ({
  trigger: {
    name: 'active_mailer.subscribe',
    params: params,
  },
  config: {
    schema: {
      status: {
        enum: [
          'success',
          'failure',
        ],
      },
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'subscribe',
      params: {
        sub_feature: 'active_mailer_overlay',
      },
    },
  },
});
